import {
  Tooltip as DSTooltip,
  TooltipProps,
  TooltipG4PProps,
  LocalizedString,
} from "@dbn/omnichannel-design-system-g4p";
import { useFormatMessage } from "../../intl";

export const useTooltipAccessibility = (
  componentType?: string,
  tooltipText?: LocalizedString,
  tooltipAriaLabel?: LocalizedString,
  tooltipCloseIconAriaLabel?: LocalizedString
) => {
  const formatMessage = useFormatMessage();
  return (
    (!componentType || componentType === "g4p") &&
    tooltipText && {
      descriptionAriaLabel: tooltipAriaLabel
        ? tooltipAriaLabel
        : formatMessage("generic.tooltip.infoIcon.ariaLabel"),
      tooltipCloseIconAriaLabel: tooltipCloseIconAriaLabel
        ? tooltipCloseIconAriaLabel
        : formatMessage("generic.tooltip.closeIcon.ariaLabel"),
    }
  );
};

export function Tooltip(props: TooltipProps | TooltipG4PProps) {
  const formatMessage = useFormatMessage();
  return (
    <DSTooltip
      childrenAriaLabel={formatMessage("generic.tooltip.infoIcon.ariaLabel")}
      closeIconAriaLabel={formatMessage("generic.tooltip.closeIcon.ariaLabel")}
      {...props}
    >
      {props.children}
    </DSTooltip>
  );
}
